import React from "react";
import { Card, Col, Row, Typography } from "antd";
import { DollarOutlined } from "@ant-design/icons";

const { Paragraph, Text, Title } = Typography;

const FuelPriceWorkbenchHeader = () => {
    return (
        <Card
            size="small"
            style={{
                marginBottom: 16,
                borderColor: "#d8c2a8",
                background: "linear-gradient(135deg, #fbf7ef 0%, #f4ecde 100%)",
            }}
        >
            <Row gutter={[24, 16]} align="middle">
                <Col flex="auto">
                    <Title level={4} style={{ margin: 0 }}>
                        <DollarOutlined style={{ marginRight: 8, color: "#ad6800" }} />
                        燃油价格确认工作台
                    </Title>
                    <Paragraph type="secondary" style={{ margin: "8px 0 0" }}>
                        主表负责发现异常周期，对比浮层负责解释双快照差异，确认与争议动作始终面向整个价格周期。
                    </Paragraph>
                </Col>
                <Col>
                    <Text strong style={{ color: "#874d00" }}>
                        周期主记录 + 双快照比较 + 周期级动作
                    </Text>
                </Col>
            </Row>
        </Card>
    );
};

export default FuelPriceWorkbenchHeader;
